import { gql, useQuery } from "@apollo/client";

export interface FaqForEdit {
  id: string;
  tenantId: string;
  question: string;
  answer: string | null;
  sortOrder: number | null;
  showOnFaqPage: boolean;
  createdAt: string;
  updatedAt: string;
}

const FAQ_FOR_EDIT = gql`
  query FaqForEdit($id: String!) {
    Faq(id: $id) {
      id
      tenantId
      question
      answer
      sortOrder
      showOnFaqPage
      createdAt
      updatedAt
    }
  }
`;

export function useFaqData(id: string | undefined) {
  const result = useQuery<{ Faq: FaqForEdit | null }>(FAQ_FOR_EDIT, {
    variables: { id: id ?? "" },
    skip: !id,
    fetchPolicy: "cache-and-network",
  });
  return {
    faq: result.data?.Faq ?? null,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
}
